import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { IUser } from '@eagerdog/interfaces';

interface IntercomProps {
  user?: IUser;
}

const IntercomWidget: React.FC<IntercomProps> = ({ user }) => {
  useEffect(() => {
    if (user) {
      Intercom({
        app_id: 'n9ns8bn0',
        user_id: user._id,
        name: user.display_name,
        email: user.email,
        created_at: user.created_at ? Math.floor(new Date(user.created_at).getTime() / 1000) : undefined, // Convert to Unix timestamp in seconds
      });
    } else {
      // Initialize Intercom without user data
      Intercom({
        app_id: 'n9ns8bn0',
      });
    }

    // Cleanup function to shutdown Intercom when component unmounts
    return () => {
      (Intercom as any)('shutdown');
    };
  }, [user]); // Re-initialize when user data changes

  return null; // This component doesn't render anything
};

export default IntercomWidget; 